import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { avatarReducer } from './avatar.reducer';
import { AvatarEffects } from './avatar.effects';

/**
 * Avatar feature state module
 * Encapsulates all avatar-related state management
 */
@NgModule({
  imports: [
    StoreModule.forFeature('avatar', avatarReducer),
    EffectsModule.forFeature([AvatarEffects])
  ]
})
export class AvatarStateModule {}
